<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="prof_edit_opt_box modal_cont" id="prof_change_user_modal">
        <img src="static/images/store/icon-close-back-popup.svg" class="btn_close">
          <h1>{{ getTranslations.home_modals_change_username_title }}</h1>
          <form action="">
            <div :class="['form-group', hasErrors ? 'has-warning' : '']">
              <input type="text"
                     v-model="username"
                     @keyup="check"
                     class="username form-group__textfield"
                     :placeholder="getTranslations.home_modals_change_username_placeholder">
              <span class="form-group__feedback"
                    v-if="hasErrors">
               {{ getMessage(messageForUsername) }}
              </span>
              <div v-if="repeat" class="failed_sent_text">{{ getTranslations.home_modals_change_username_repeat }}</div>
            </div>
            <button type="submit"
                   @click.prevent="updateUsernameAction()"
                    :class="['ti_btn--main', hasErrors || !username ? 'deactivated' : '']">{{ getTranslations.home_modals_change_username_save }}</button>
          </form>
          <div class="success_update" v-if="success">
             {{ getTranslations.home_modals_change_username_success }}
          </div>
        <p class="info_symbol">&#9432;</p>
        <p class="info_text">Please note that you can change your username only once!</p>
    </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'change-username',
  data() {
    return {
      hasErrors: false,
      success: false,
      repeat: false,
      username: '',
      messageForUsername: '',
    };
  },
  created() {
    this.showModal();
  },
  methods: {
    ...mapActions('profile', [
      'changeUsername',
      'storeLoginInfo',
    ]),
    ...mapMutations('common', [
      'updateUsername',
    ]),
    getMessage(key) {
      if (key === 'SERVER_ERROR') return key;
      return this.getTranslations[key] || '';
    },
    check(evt) {
      const max = 12;
      const min = 3;
      this.hasErrors = false;
      this.messageForUsername = '';
      if (!this.username) {
        this.hasErrors = false;
      } else {
        // eslint-disable-next-line
        if (this.username.length < min) {
          this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_at_least_3_chars_long';
          this.hasErrors = true;
        } else {
          if (this.username.length > max) {
            this.username = this.checkMaxChar(this.username, max, evt);
            this.hasErrors = true;
          }
          this.hasErrors = false;
          // eslint-disable-next-line
          const validUsernameRegex = /^(?!.*[\0\b\n\f\r\t\s-!@#\$%\=.^\&*(\+\/?\[\]|΄΄;:<>}{'"¨,)`~\\])_?.+$/;
          const validUsername = this.username.match(validUsernameRegex);
          if (validUsername === null) {
            this.hasErrors = true;
            this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_criteria';
            return;
          }
          this.$axios.get(`publicapi/checkUsername?username=${this.username}&msisdn=${encodeURIComponent(this.userDetails.msisdn)}`).then((response) => {
            const res = response.data.data.msg;
            if (res === 'Username exists') {
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_taken_below';
              this.hasErrors = true;
            } else if (res === 'Invalid') {
              this.hasErrors = true;
              this.messageForUsername = 'visitor_sign_up_3_warning_msg_username_blacklist_word';
            } else {
              this.messageForUsername = response.data.data.msg;
            }
          });
        }
      }
    },
    checkMaxChar(value, max, evt) {
      if (value.length > max) {
        /* eslint-disable */
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode.which < 0x20) {
          return;     // Do nothing
        }
        if (value.length === max) {
          charCode.preventDefault();
        } else if (value.length > max) {
          return value.substring(0, max);
        }
        /* eslint-enable */
      }
    },
    updateUsernameAction() {
      if (!this.username) return;
      this.changeUsername({ username: this.username }).then((response) => {
        const res = response.data.responseEnum;
        if (res === 'OPERATION_SUCCESS') {
          this.success = true;
          this.updateUsername(this.username);
          this.storeLoginInfo({ token: response.data.data, username: this.username, rememberMeParameter: true });
        } else {
          this.repeat = true;
          this.hasErrors = true;
        }
      });
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.prof_edit_opt_box,.overlay').fadeIn(200);
        // show/hide modal
        $('.btn_close, .overlay').click(function () {
          vm.$emit('close');
          $('#changeUsername').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ChangeUsername.vue